var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.899 11.3966C17.7724 11.1169 17.4942 10.9387 17.1879 10.9387H14.0626V0.781338C14.0626 0.350039 13.7125 0 13.2812 0H10.1559C9.7246 0 9.37456 0.350039 9.37456 0.781338V10.9387H6.24921C5.94292 10.9387 5.66477 11.1184 5.53819 11.3966C5.41005 11.6763 5.46006 12.0029 5.66164 12.2342L11.131 18.4849C11.2795 18.6552 11.4935 18.7521 11.7186 18.7521C11.9436 18.7521 12.1577 18.6537 12.3061 18.4849L17.7755 12.2342C17.9787 12.0045 18.0255 11.6763 17.899 11.3966Z",
    fill: "#556BB8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3148 17.1868V21.8748H3.12535V17.1868H0V23.4375C0 24.3016 0.700079 25.0001 1.56268 25.0001H21.8775C22.7416 25.0001 23.4401 24.3016 23.4401 23.4375V17.1868H20.3148Z",
    fill: "#556BB8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadBlue);
export default __webpack_public_path__ + "static/media/download-blue.f84b6da2002d5013067eb24e6d2f0a1e.svg";
export { ForwardRef as ReactComponent };